import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import careerSvg from '../assets/career.svg'; 

const Career = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Main Content */}
      <Container
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          py: 1, // same reduced padding
        }}
      >
        <Box
          component="img"
          src={careerSvg}
          alt="Career"
          sx={{
            width: '100%',
            maxWidth: 620,
            mb: 3,
          }}
        />

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Our All chairs are Currently filled.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{
            bgcolor: '#1a7f3a',
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            '&:hover': {
              bgcolor: '#0f5328',
            },
          }}
        >
          Go Home
        </Button>
      </Container>

      {/* Footer */}
      <Box
        sx={{
          textAlign: 'center',
          py: 2,
          borderTop: '1px solid #E5E7EB',
        }}
      >
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} SeekDeals. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Career;
